import { render, staticRenderFns } from "./WorkCurrencyDialog.vue?vue&type=template&id=aaf339f2"
import script from "./WorkCurrencyDialog.vue?vue&type=script&lang=js"
export * from "./WorkCurrencyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports